const normalizeLinks = (links) => {
    if (!links) return [];

    // If already array of objects
    if (Array.isArray(links)) return links.filter(Boolean);

    // If backend sends JSON as string
    if (typeof links === "string") {
        const trimmed = links.trim();
        if (!trimmed) return [];

        // Try JSON parse first
        if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
            try {
                const parsed = JSON.parse(trimmed);
                if (Array.isArray(parsed)) return parsed.filter(Boolean);
            } catch {
                // fallthrough
            }
        }

        // Fallback: treat as newline/comma separated urls
        return trimmed
            .split(/\r?\n|,/g)
            .map((s) => s.trim())
            .filter(Boolean)
            .map((url) => ({
                name: url,
                url: url.startsWith("http") ? url : `https://${url}`,
            }));
    }

    // Anything else (object/number/etc)
    return [];
};

const ChecklistItemsList = ({ links }) => {
    const safeLinks = normalizeLinks(links);

    if (safeLinks.length === 0) return null;

    return (
        <div className="flex items-center">
            <ul className="max-w-md mb-4 space-y-1 list-disc list-inside">
                {safeLinks.map((link, idx) => {
                    const name = link?.name ?? link?.url ?? `Link ${idx + 1}`;
                    const url = link?.url ?? "";
                    if (!url) return null;

                    return (
                        <li key={`${name}-${idx}`}>
                            <a
                                target="_blank"
                                className="font-normal text-blue-600 hover:underline"
                                rel="noreferrer"
                                href={url}
                            >
                                {name}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default ChecklistItemsList;
